import {
    SchedulingWorkshiftModel,
    SchedulingWorkshiftModelAPI,
} from '../../../../models';

export const createWorkshiftsSchedulingAdapter = (
    response: SchedulingWorkshiftModelAPI
): SchedulingWorkshiftModel => {
    return {
        data: response.daysResponse.data,
    };
};
